'use strict';

import _ from 'underscore';
import $ from 'jquery';
import mediator from '../../js/mediator';
import config from '../../js/config';
import Analytics from '../Analytics/Analytics';

export const IMPRESSION_TRACK_THROTTLE_MILLISECONDS = 50;
export const IMPRESSION_REQUIRED_VIEW_MILLISECONDS = 1000;
export const IMPRESSION_CSS_CLASSNAME = '.gtm-impression-tracking';
export const IMPRESSION_DATA_ATTRNAME = 'analytics';
export const CAROUSEL_INACTIVE_SLIDE_ZINDEX = 998;

$('.HeroCarousel-link').on('focus', function() {
  var btnArray = document.getElementsByClassName('HeroCarousel-button');
  Array.from(btnArray).forEach(element => {
    var label = element.getAttribute('data-gtm-label');
    element.setAttribute('aria-label', label);
  });
  $(this).removeAttr('aria-hidden');
  $(this).parent().removeAttr('aria-hidden');
  $(this).find('a').each(function() {
    $(this).attr('tabindex', '-1');
    $(this).attr('aria-hidden',true);
  });
});

$('.HeroCarousel-link').on('blur', function() {
  $(this).find('a').each(function() {
    $(this).removeAttr('tabindex');
    $(this).removeAttr('aria-hidden');
  });
});

$('.HeroCarousel-button').on('focus', function() {
  $(this).removeAttr('aria-hidden');
  $(this).parent().removeAttr('aria-hidden');
});

export class ImpressionsTracking {
  constructor() {
    this.elementsList = [];
    this.throttledCheck = _.throttle(this.checkVisibilityOfElements.bind(this, false), IMPRESSION_TRACK_THROTTLE_MILLISECONDS, { leading: false });

    this.bindEvents();
  }

  bindEvents() {
    mediator.on(config.events.impressions.check, this.throttledCheck, this);
    mediator.on(config.events.carousel.slideChanged, this.throttledCheck, this);
    mediator.on(config.events.ui.scrollThrottle, this.throttledCheck, this);
    mediator.on(config.events.ui.resizeThrottle, this.throttledCheck, this);
  }

  initialize() {
    setTimeout(this.throttledCheck, IMPRESSION_REQUIRED_VIEW_MILLISECONDS);
  }

  addElementsToTrack(elements) {
    if (elements) {
      elements.each((index, element) => {
        if (!(element instanceof $)) {
          element = $(element);
        }
        this.elementsList.push({
          element,
          isInViewport: false,
          visibilityStartTimestamp: null
        });
      });
    }
  }

  checkVisibilityOfElements(recheck = false) {
    if (this.checkTimeout) { // clear delayed recheck since we are checking now
      clearTimeout(this.checkTimeout);
      this.checkTimeout = null;
    }
    let triggeredElements = [];
    this.elementsList.forEach((el, index, object) => {
      if (this.isElementVisible(el.element) && this.isElementInViewport(el.element)) { // the element is visible
        if (el.isInViewport
          && (this.getTimestamp() - el.visibilityStartTimestamp) >= IMPRESSION_REQUIRED_VIEW_MILLISECONDS) { // and it's been visible for the required time
          triggeredElements.push(el.element);
          object.splice(index, 1); // remove the element
        } else if (!el.isInViewport || !el.visibilityStartTimestamp) { // and it was not visible before
          el.isInViewport = true;
          el.visibilityStartTimestamp = this.getTimestamp();
        }
      } else { // the element is not visible
        el.isInViewport = false;
        el.visibilityStartTimestamp = null;
      }
    });
    if (triggeredElements.length > 0) {
      this.triggerImpressions(triggeredElements);
    }
    if (!recheck) { // trigger a delayed recheck unless it's already a recheck
      this.checkTimeout = setTimeout(this.checkVisibilityOfElements.bind(this, true), IMPRESSION_REQUIRED_VIEW_MILLISECONDS);
    }
  }

  isElementVisible(element) {
    if (!(element instanceof $)) {
      element = $(element);
    }
    let zIndexFlag = true;
    if (element.hasClass('HeroCarousel-link')) {
      let parent = element.parent();
      let zIndexText = parent && jQuery(parent).css('z-index');
      let zIndex = parseInt(zIndexText);
      zIndexFlag = zIndex !== CAROUSEL_INACTIVE_SLIDE_ZINDEX;
    }
    return zIndexFlag && element.is(':visible');
  }

  isElementInViewport(element, _window = window) {
    if (element instanceof $) {
      element = element[0];
    }
    var rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (_window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (_window.innerWidth || document.documentElement.clientWidth)
    );
  }

  getTimestamp() {
    return new Date().getTime();
  }

  triggerImpressions(elements) {
    let promotions = _.map(elements, element => {
      let analyticsData = element.data(IMPRESSION_DATA_ATTRNAME);
      if (analyticsData && analyticsData.PromotionPosition && analyticsData.PromotionPosition !== 'null') {
        return {
          id: analyticsData.PromotionId,
          name: analyticsData.PromotionName,
          creative: analyticsData.PromotionCreative,
          position: analyticsData.PromotionPosition
        }
      } else {
        return null;
      }
    }).filter(element => element !== null);
    if (promotions.length > 0) {
      Analytics.ecommercePushWithCurrency(config.analytics.eventTypes.PromoImpression, { promoView: { promotions }});
    }
  }
}

export let impressionsTracking = new ImpressionsTracking();;

export function createImpressionsTracking($parent) {
  impressionsTracking.addElementsToTrack($parent.find(IMPRESSION_CSS_CLASSNAME));
}


// WEBPACK FOOTER //
// ./assets/components/ImpressionsTracking/ImpressionsTracking.js